export const padNumber = (value: number): string => {
  if (value > 9 || value < 0) {
    return value.toString();
  }

  return `0${value}`;
};

export const isDateValid = ({
  year,
  month,
  day,
}: {
  year: string;
  month: string;
  day: string;
}) => {
  const parsedDate = new Date(
    `${year}-${padNumber(+month)}-${padNumber(+day)}`
  );
  return (
    !Number.isNaN(parsedDate.valueOf()) &&
    parsedDate.getUTCFullYear() === +year &&
    parsedDate.getUTCMonth() === +month - 1 &&
    parsedDate.getUTCDate() === +day
  );
};
